import React, { forwardRef } from "react";
import { Badge, badgeClasses, styled } from "@mui/material";
import Tooltip from "@hyro-components/Tooltip";
import BellIcon from "src/icons/BellIcon";
import { StyledIconButton } from "src/layout/Header/HeaderStyles";
import useAppStore from "src/stores/appStore";

const NotificationButton = forwardRef(({ onClick }, ref) => {
  const { notificationsCount } = useAppStore();

  const handleClick = (e) => {
    if (onClick) onClick(e);
  };

  return (
    <Tooltip title="Notifications">
      <StyledIconButton
        data-testid="notifications-button"
        onClick={handleClick}
        ref={ref}
      >
        <StyledBadge
          overlap="circular"
          color="primary"
          badgeContent={notificationsCount}
          invisible={!notificationsCount}
          data-testid="notifications-badge"
        >
          <BellIcon />
        </StyledBadge>
      </StyledIconButton>
    </Tooltip>
  );
});

const StyledBadge = styled(Badge)({
  fontSize: 11,
  [`.${badgeClasses.badge}`]: {
    minWidth: 18,
    height: 18
  }
});

NotificationButton.displayName = "NotificationButton";

export default NotificationButton;
